import { Controller } from "@hotwired/stimulus"
import throttle from "../../utils/throttle"
export default class extends Controller {
    connect() {
        //this.onScrollEvent = throttle(this.checkSticky, 150).bind(this);
        document.addEventListener("scroll", this.checkSticky.bind(this));
        this.checkSticky();
    }
    checkSticky(event) {
        if(!window.matchMedia("(max-width:999px)").matches) {
            if(window.scrollY > 100) {
                this.element.setAttribute('data-sticky',"true");
            } else {
                this.element.removeAttribute('data-sticky');
            }
        }
    }
    openSubmenu(event) {
        if(window.matchMedia("(max-width:999px)").matches) {
            event.preventDefault();
            let menuItem = event.target.closest('li');
            if(menuItem) {
                if(menuItem.getAttribute('data-open')) {
                    menuItem.removeAttribute('data-open');
                } else {
                    menuItem.setAttribute('data-open','true');
                }
            }
        }
    }
}